var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimetable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 12.9843C10.4982 12.9843 12.9843 10.4982 12.9843 7.43136C12.9843 4.36455 10.4982 1.87842 7.43137 1.87842C4.36457 1.87842 1.87843 4.36455 1.87843 7.43136C1.87843 10.4982 4.36457 12.9843 7.43137 12.9843Z",
    fill: "url(#paint0_linear_2262_4547)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 12.2132C10.0723 12.2132 12.2132 10.0722 12.2132 7.43129C12.2132 4.79033 10.0723 2.64941 7.43137 2.64941C4.79041 2.64941 2.64949 4.79033 2.64949 7.43129C2.64949 10.0722 4.79041 12.2132 7.43137 12.2132Z",
    fill: "url(#paint1_linear_2262_4547)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87843 7.43135C1.87843 10.4981 4.36456 12.9843 7.43137 12.9843C10.4982 12.9843 12.9843 10.4981 12.9843 7.43135C12.9843 6.76716 12.8673 6.13041 12.6534 5.54004H2.20928C1.99543 6.13041 1.87843 6.76716 1.87843 7.43135Z",
    fill: "url(#paint2_linear_2262_4547)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50483 11.3578C5.6734 13.5264 9.18933 13.5264 11.3579 11.3578C13.5265 9.18927 13.5265 5.67334 11.3579 3.50477C10.8882 3.03512 10.3552 2.66759 9.78658 2.40137L2.40143 9.78649C2.66765 10.3552 3.03518 10.8882 3.50483 11.3578Z",
    fill: "url(#paint3_linear_2262_4547)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 11.6612C9.76748 11.6612 11.6613 9.76744 11.6613 7.43132C11.6613 5.09521 9.76748 3.20142 7.43137 3.20142C5.09526 3.20142 3.20146 5.09521 3.20146 7.43132C3.20146 9.76744 5.09526 11.6612 7.43137 11.6612Z",
    fill: "url(#paint4_linear_2262_4547)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6612 7.43132C11.6612 5.09523 9.76746 3.20142 7.43134 3.20142C5.09524 3.20142 3.20143 5.09523 3.20143 7.43132C3.20143 7.93726 3.29056 8.42232 3.45346 8.87201H11.4092C11.5721 8.42232 11.6612 7.93726 11.6612 7.43132Z",
    fill: "url(#paint5_linear_2262_4547)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4223 4.44032C8.77046 2.78845 6.09224 2.78845 4.44037 4.44032C2.78849 6.0922 2.78849 8.77042 4.44037 10.4223C4.79812 10.78 5.20412 11.06 5.63731 11.2628L11.2629 5.63726C11.0601 5.2041 10.7801 4.7981 10.4223 4.44032Z",
    fill: "url(#paint6_linear_2262_4547)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48713 3.38916L7.16985 7.37757L10.3165 10.5243C10.3522 10.4909 10.3876 10.4572 10.4223 10.4224C11.2153 9.62944 11.6274 8.59997 11.659 7.56107L7.48713 3.38916Z",
    fill: "url(#paint7_linear_2262_4547)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05702 7.80579L8.31465 9.06341C8.5208 9.26957 8.85765 9.27816 9.06537 9.07357C9.06808 9.07088 9.0708 9.06819 9.07346 9.06547C9.27805 8.85779 9.26946 8.52091 9.0633 8.31475L7.80568 7.05713L7.05702 7.80579Z",
    fill: "url(#paint8_linear_2262_4547)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 3.71655C7.34928 3.71655 7.28271 3.78311 7.28271 3.86521V4.43833C7.28271 4.52043 7.34928 4.58699 7.43137 4.58699C7.51346 4.58699 7.58003 4.52043 7.58003 4.43833V3.86521C7.58003 3.78311 7.51346 3.71655 7.43137 3.71655Z",
    fill: "url(#paint9_linear_2262_4547)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 10.2754C7.34928 10.2754 7.28271 10.342 7.28271 10.424V10.9972C7.28271 11.0793 7.34928 11.1458 7.43137 11.1458C7.51346 11.1458 7.58003 11.0793 7.58003 10.9972V10.424C7.58003 10.342 7.51346 10.2754 7.43137 10.2754Z",
    fill: "url(#paint10_linear_2262_4547)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9974 7.28247H10.4243C10.3422 7.28247 10.2756 7.34903 10.2756 7.43113C10.2756 7.51322 10.3422 7.57978 10.4243 7.57978H10.9974C11.0795 7.57978 11.1461 7.51322 11.1461 7.43113C11.146 7.34903 11.0795 7.28247 10.9974 7.28247Z",
    fill: "url(#paint11_linear_2262_4547)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58713 7.43113C4.58713 7.34903 4.52057 7.28247 4.43847 7.28247H3.86535C3.78325 7.28247 3.71669 7.34903 3.71669 7.43113C3.71669 7.51322 3.78325 7.57978 3.86535 7.57978H4.43847C4.5206 7.57978 4.58713 7.51322 4.58713 7.43113Z",
    fill: "url(#paint12_linear_2262_4547)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77709 4.26869C5.73603 4.19759 5.64513 4.17322 5.57403 4.21428C5.50294 4.25534 5.47856 4.34625 5.51963 4.41734L5.80619 4.91369C5.84725 4.98478 5.93816 5.00916 6.00925 4.96809C6.08034 4.92703 6.10472 4.83613 6.06366 4.76503L5.77709 4.26869Z",
    fill: "url(#paint13_linear_2262_4547)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05656 9.94886C9.0155 9.87777 8.92459 9.8534 8.8535 9.89446C8.7824 9.93552 8.75803 10.0264 8.79909 10.0975L9.08565 10.5939C9.12672 10.665 9.21762 10.6893 9.28872 10.6483C9.35981 10.6072 9.38418 10.5163 9.34312 10.4452L9.05656 9.94886Z",
    fill: "url(#paint14_linear_2262_4547)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0976 6.06349L10.5939 5.77693C10.665 5.73586 10.6894 5.64496 10.6483 5.57386C10.6073 5.50277 10.5164 5.4784 10.4453 5.51946L9.94894 5.80602C9.87785 5.84708 9.85347 5.93799 9.89453 6.00908C9.9356 6.08018 10.0265 6.10452 10.0976 6.06349Z",
    fill: "url(#paint15_linear_2262_4547)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76512 8.79901L4.26878 9.08557C4.19769 9.12663 4.17331 9.21754 4.21437 9.28863C4.25544 9.35972 4.34634 9.3841 4.41744 9.34304L4.91378 9.05647C4.98487 9.01541 5.00925 8.92451 4.96819 8.85341C4.92715 8.78229 4.83622 8.75794 4.76512 8.79901Z",
    fill: "url(#paint16_linear_2262_4547)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28872 4.21428C9.21762 4.17322 9.12668 4.19759 9.08565 4.26869L8.79909 4.76503C8.75803 4.83613 8.7824 4.92706 8.8535 4.96809C8.92459 5.00916 9.01553 4.98478 9.05656 4.91369L9.34312 4.41734C9.38415 4.34625 9.35981 4.25531 9.28872 4.21428Z",
    fill: "url(#paint17_linear_2262_4547)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00925 9.89446C5.93816 9.8534 5.84722 9.87777 5.80619 9.94886L5.51963 10.4452C5.47856 10.5163 5.50294 10.6072 5.57403 10.6483C5.64513 10.6893 5.73606 10.665 5.77709 10.5939L6.06366 10.0975C6.10472 10.0264 6.08034 9.93549 6.00925 9.89446Z",
    fill: "url(#paint18_linear_2262_4547)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91378 5.80602L4.41744 5.51946C4.34634 5.4784 4.2554 5.50277 4.21437 5.57386C4.17331 5.64496 4.19769 5.7359 4.26878 5.77693L4.76512 6.06349C4.83622 6.10455 4.92715 6.08018 4.96819 6.00908C5.00925 5.93799 4.98487 5.84708 4.91378 5.80602Z",
    fill: "url(#paint19_linear_2262_4547)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.594 9.08556L10.0976 8.799C10.0265 8.75794 9.9356 8.78231 9.89456 8.85341C9.8535 8.9245 9.87788 9.01544 9.94897 9.05647L10.4453 9.34303C10.5164 9.38409 10.6073 9.35972 10.6484 9.28862C10.6894 9.21753 10.6651 9.12659 10.594 9.08556Z",
    fill: "url(#paint20_linear_2262_4547)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43138 7.37754H7.16988V4.85441C7.16988 4.41616 7.22309 3.97951 7.32834 3.55407L7.36244 3.41626C7.38025 3.34432 7.4825 3.34432 7.50028 3.41626L7.53438 3.55407C7.63966 3.97951 7.69284 4.41616 7.69284 4.85441V7.37754H7.43138Z",
    fill: "url(#paint21_linear_2262_4547)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38922 7.43141L7.20432 7.2465L8.35603 6.09478C8.66594 5.78488 9.01232 5.51375 9.38757 5.28738L9.50913 5.21403C9.57257 5.17575 9.64488 5.24807 9.6066 5.3115L9.53325 5.43307C9.30685 5.80832 9.03572 6.15472 8.72585 6.4646L7.57413 7.61632L7.38922 7.43141Z",
    fill: "url(#paint22_linear_2262_4547)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43137 7.96085C7.72373 7.96085 7.96074 7.72384 7.96074 7.43147C7.96074 7.13911 7.72373 6.9021 7.43137 6.9021C7.139 6.9021 6.90199 7.13911 6.90199 7.43147C6.90199 7.72384 7.139 7.96085 7.43137 7.96085Z",
    fill: "url(#paint23_linear_2262_4547)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90196 7.43153C6.90196 7.72391 7.13896 7.96091 7.43134 7.96091C7.72371 7.96091 7.96071 7.72391 7.96071 7.43153C7.96071 7.36822 7.94956 7.3075 7.92918 7.25122H6.93349C6.91312 7.3075 6.90196 7.36822 6.90196 7.43153Z",
    fill: "url(#paint24_linear_2262_4547)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05703 7.80575C7.26378 8.0125 7.59897 8.0125 7.80569 7.80575C8.01244 7.599 8.01244 7.26381 7.80569 7.05709C7.76091 7.01231 7.71009 6.97728 7.65588 6.9519L6.95181 7.65597C6.97722 7.71015 7.01225 7.76097 7.05703 7.80575Z",
    fill: "url(#paint25_linear_2262_4547)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1862 8.58804C11.1862 9.31086 11.6213 9.9317 12.2437 10.2039C12.8414 9.16795 13.0771 7.98054 12.9509 6.82498C12.9504 6.82498 12.9499 6.82495 12.9493 6.82495C11.9755 6.82495 11.1862 7.61426 11.1862 8.58804Z",
    fill: "url(#paint26_linear_2262_4547)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61859 2.80474C4.56619 2.02208 5.69784 1.57508 6.85575 1.46405C6.93428 1.45652 6.9939 1.39011 6.9939 1.31124V0.153954C6.9939 0.0638292 6.91678 -0.00676453 6.82697 0.000516717C5.31315 0.122923 3.82975 0.705892 2.60403 1.74961C2.5355 1.80795 2.53103 1.91236 2.59469 1.97602L3.41294 2.79427C3.46865 2.84999 3.55781 2.85492 3.61859 2.80474Z",
    fill: "url(#paint27_linear_2262_4547)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80475 11.2442C2.02206 10.2966 1.57509 9.16496 1.46406 8.00705C1.45653 7.92852 1.39013 7.8689 1.31125 7.8689H0.153969C0.0638445 7.8689 -0.00674927 7.94602 0.000531975 8.03583C0.122938 9.54965 0.705907 11.0331 1.74963 12.2588C1.80797 12.3273 1.91238 12.3318 1.97603 12.2681L2.79428 11.4499C2.84997 11.3941 2.85494 11.305 2.80475 11.2442Z",
    fill: "url(#paint28_linear_2262_4547)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46406 6.85566C1.57509 5.69775 2.02206 4.56609 2.80475 3.6185C2.85493 3.55772 2.85 3.46856 2.79425 3.41284L1.976 2.59459C1.91234 2.53094 1.80793 2.53541 1.74959 2.60394C0.705872 3.82966 0.122903 5.31306 0.000497216 6.82688C-0.00675278 6.91669 0.063841 6.99381 0.153935 6.99381H1.31125C1.39012 6.99381 1.45653 6.93419 1.46406 6.85566Z",
    fill: "url(#paint29_linear_2262_4547)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85575 13.3986C5.69784 13.2875 4.56619 12.8406 3.61859 12.0579C3.55781 12.0077 3.46865 12.0126 3.41294 12.0684L2.59469 12.8866C2.53103 12.9503 2.5355 13.0547 2.60403 13.113C3.82975 14.1568 5.31315 14.7397 6.82697 14.8621C6.91678 14.8694 6.9939 14.7988 6.9939 14.7087V13.5514C6.9939 13.4725 6.93425 13.4061 6.85575 13.3986Z",
    fill: "url(#paint30_linear_2262_4547)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8412 9.32087L15.2971 9.00652C15.321 8.87074 15.3337 8.73105 15.3337 8.58824C15.3337 8.44543 15.321 8.30577 15.2971 8.16996L15.8412 7.85562C15.993 7.76812 16.045 7.57412 15.9574 7.4224L15.4632 6.56602C15.3755 6.4143 15.1815 6.36243 15.0297 6.4499L14.485 6.7644C14.2722 6.58502 14.0277 6.44224 13.761 6.34565V5.71743C13.761 5.54212 13.6188 5.40015 13.4437 5.40015H12.4549C12.2798 5.40015 12.1377 5.54212 12.1377 5.71743V6.34565C11.8709 6.44224 11.6264 6.58502 11.4137 6.7644L10.8689 6.4499C10.7172 6.3624 10.5231 6.41427 10.4355 6.56602L9.94125 7.4224C9.85359 7.57412 9.90562 7.76815 10.0574 7.85562L10.6015 8.16996C10.5776 8.30574 10.5649 8.44546 10.5649 8.58824C10.5649 8.73102 10.5776 8.87071 10.6015 9.00652L10.0574 9.32087C9.90565 9.40837 9.85359 9.60237 9.94125 9.75408L10.4355 10.6105C10.5231 10.7622 10.7171 10.8141 10.8689 10.7266L11.4137 10.4121C11.6264 10.5914 11.871 10.7342 12.1377 10.8308V11.459C12.1377 11.6343 12.2798 11.7763 12.4549 11.7763H13.4437C13.6188 11.7763 13.761 11.6343 13.761 11.459V10.8308C14.0277 10.7342 14.2722 10.5915 14.485 10.4121L15.0297 10.7266C15.1815 10.8141 15.3755 10.7622 15.4632 10.6105L15.9574 9.75412C16.045 9.60237 15.993 9.40833 15.8412 9.32087ZM12.9493 9.82387C12.2669 9.82387 11.7137 9.27062 11.7137 8.58824C11.7137 7.90587 12.2669 7.35262 12.9493 7.35262C13.6317 7.35262 14.1849 7.90587 14.1849 8.58824C14.1849 9.27062 13.6317 9.82387 12.9493 9.82387Z",
    fill: "url(#paint31_linear_2262_4547)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9493 6.8252C11.9755 6.8252 11.1862 7.61451 11.1862 8.58829C11.1862 9.56207 11.9755 10.3514 12.9493 10.3514C13.9231 10.3514 14.7124 9.56207 14.7124 8.58829C14.7124 7.61451 13.9231 6.8252 12.9493 6.8252ZM12.9493 9.73938C12.3136 9.73938 11.7982 9.22398 11.7982 8.58829C11.7982 7.9526 12.3136 7.4372 12.9493 7.4372C13.585 7.4372 14.1004 7.9526 14.1004 8.58829C14.1004 9.22398 13.585 9.73938 12.9493 9.73938Z",
    fill: "url(#paint32_linear_2262_4547)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6016 9.00659L10.0573 9.32084C9.9056 9.40844 9.8536 9.60247 9.9412 9.75418L10.4355 10.6104C10.5231 10.7622 10.7172 10.8142 10.8689 10.7266L11.4136 10.4121C10.9959 10.06 10.7008 9.56715 10.6016 9.00659Z",
    fill: "url(#paint33_linear_2262_4547)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6016 9.00659L10.0573 9.32084C9.9056 9.40844 9.8536 9.60247 9.9412 9.75418L10.4355 10.6104C10.5231 10.7622 10.7172 10.8142 10.8689 10.7266L11.4136 10.4121C10.9959 10.06 10.7008 9.56715 10.6016 9.00659Z",
    fill: "url(#paint34_linear_2262_4547)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9575 7.42239L15.4631 6.56614C15.3755 6.41442 15.1815 6.36242 15.0298 6.45002L14.485 6.76452C14.9027 7.11658 15.1979 7.60942 15.2971 8.16999L15.8414 7.85574C15.9931 7.76817 16.0451 7.57414 15.9575 7.42239Z",
    fill: "url(#paint35_linear_2262_4547)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9493 6.2039C13.2343 6.2039 13.5076 6.25399 13.7609 6.34568V5.7174C13.7609 5.54218 13.6189 5.40015 13.4437 5.40015H12.4549C12.2797 5.40015 12.1377 5.54218 12.1377 5.7174V6.34568C12.3911 6.25396 12.6644 6.2039 12.9493 6.2039Z",
    fill: "url(#paint36_linear_2262_4547)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9493 10.9726C12.6643 10.9726 12.3911 10.9225 12.1377 10.8308V11.4591C12.1377 11.6343 12.2798 11.7763 12.455 11.7763H13.4437C13.6189 11.7763 13.7609 11.6343 13.7609 11.4591V10.8308C13.5076 10.9225 13.2343 10.9726 12.9493 10.9726Z",
    fill: "url(#paint37_linear_2262_4547)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9493 10.9726C12.6643 10.9726 12.3911 10.9225 12.1377 10.8308V11.4591C12.1377 11.6343 12.2798 11.7763 12.455 11.7763H13.4437C13.6189 11.7763 13.7609 11.6343 13.7609 11.4591V10.8308C13.5076 10.9225 13.2343 10.9726 12.9493 10.9726Z",
    fill: "url(#paint38_linear_2262_4547)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4136 6.76452L10.8689 6.45002C10.7172 6.36243 10.5231 6.4144 10.4355 6.56615L9.94119 7.4224C9.85359 7.57412 9.90556 7.76815 10.0573 7.85574L10.6016 8.16999C10.7008 7.60943 10.9959 7.11659 11.4136 6.76452Z",
    fill: "url(#paint39_linear_2262_4547)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8413 9.32084L15.297 9.00659C15.1978 9.56715 14.9027 10.06 14.485 10.4121L15.0297 10.7266C15.1814 10.8142 15.3755 10.7622 15.4631 10.6104L15.9574 9.75418C16.0451 9.60247 15.9931 9.40844 15.8413 9.32084Z",
    fill: "url(#paint40_linear_2262_4547)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8413 9.32084L15.297 9.00659C15.1978 9.56715 14.9027 10.06 14.485 10.4121L15.0297 10.7266C15.1814 10.8142 15.3755 10.7622 15.4631 10.6104L15.9574 9.75418C16.0451 9.60247 15.9931 9.40844 15.8413 9.32084Z",
    fill: "url(#paint41_linear_2262_4547)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 12.2943L11.9006 12.2595C11.8779 12.175 11.8478 12.0913 11.8095 12.0092C11.7712 11.9271 11.7265 11.8502 11.6763 11.7786L11.9049 11.452C11.9686 11.361 11.9465 11.2356 11.8555 11.1719L11.3418 10.812C11.2508 10.7483 11.1253 10.7705 11.0615 10.8615L10.8327 11.1883C10.6623 11.1422 10.4834 11.1257 10.3042 11.1417L10.1358 10.7805C10.0888 10.6798 9.96907 10.6363 9.86838 10.6832L9.29998 10.9482C9.19929 10.9952 9.15563 11.1149 9.20263 11.2157L9.37104 11.5768C9.2436 11.7038 9.14129 11.8515 9.0671 12.0116L8.6696 11.9769C8.55891 11.9672 8.46129 12.0491 8.45157 12.1598L8.39704 12.7846C8.38732 12.8953 8.46926 12.9929 8.57991 13.0025L8.97698 13.0373C8.99963 13.1218 9.02979 13.2055 9.06807 13.2876C9.10635 13.3697 9.15107 13.4466 9.20123 13.5182L8.97269 13.8448C8.90891 13.9357 8.93101 14.0612 9.02207 14.1249L9.53573 14.4847C9.62679 14.5485 9.75223 14.5263 9.81601 14.4353L10.0449 14.1085C10.2153 14.1545 10.3941 14.1711 10.5733 14.1551L10.7417 14.5162C10.7887 14.617 10.9085 14.6605 11.0092 14.6136L11.5776 14.3485C11.6783 14.3016 11.7219 14.1819 11.6749 14.0811L11.5065 13.72C11.6339 13.5929 11.7363 13.4453 11.8104 13.2851L12.2079 13.3199C12.3186 13.3295 12.4163 13.2477 12.426 13.137L12.4805 12.5122C12.4902 12.4015 12.4083 12.3039 12.2976 12.2943ZM10.77 13.3587C10.3777 13.5416 9.91138 13.3719 9.72848 12.9796C9.54557 12.5873 9.71529 12.121 10.1076 11.938C10.4999 11.7551 10.9662 11.9249 11.1491 12.3171C11.332 12.7094 11.1623 13.1758 10.77 13.3587Z",
    fill: "url(#paint42_linear_2262_4547)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96617 11.6349C9.40638 11.8959 9.16423 12.5612 9.42526 13.121C9.68629 13.6808 10.3516 13.923 10.9114 13.6619C11.4712 13.4009 11.7134 12.7356 11.4523 12.1758C11.1913 11.616 10.5259 11.3738 9.96617 11.6349ZM10.7473 13.3101C10.3819 13.4805 9.94745 13.3224 9.77704 12.9569C9.60663 12.5915 9.76476 12.157 10.1302 11.9866C10.4956 11.8162 10.9301 11.9744 11.1005 12.3398C11.2709 12.7052 11.1128 13.1397 10.7473 13.3101Z",
    fill: "url(#paint43_linear_2262_4547)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20129 13.5181L8.97263 13.8446C8.90888 13.9356 8.93101 14.0611 9.02204 14.1248L9.53576 14.4845C9.62679 14.5483 9.75226 14.5262 9.81601 14.4351L10.0449 14.1083C9.71035 14.0179 9.4086 13.8137 9.20129 13.5181Z",
    fill: "url(#paint44_linear_2262_4547)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20129 13.5181L8.97263 13.8446C8.90888 13.9356 8.93101 14.0611 9.02204 14.1248L9.53576 14.4845C9.62679 14.5483 9.75226 14.5262 9.81601 14.4351L10.0449 14.1083C9.71035 14.0179 9.4086 13.8137 9.20129 13.5181Z",
    fill: "url(#paint45_linear_2262_4547)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 11.1717L11.3418 10.812C11.2507 10.7483 11.1253 10.7704 11.0615 10.8615L10.8327 11.1883C11.1672 11.2787 11.4689 11.4829 11.6762 11.7785L11.9049 11.452C11.9686 11.361 11.9465 11.2355 11.8555 11.1717Z",
    fill: "url(#paint46_linear_2262_4547)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79963 11.2777C9.96344 11.2013 10.134 11.1569 10.3042 11.1417L10.1358 10.7805C10.0888 10.6798 9.9691 10.6362 9.86838 10.6832L9.30001 10.9482C9.19929 10.9952 9.15572 11.1149 9.20266 11.2156L9.37107 11.5768C9.49213 11.4562 9.63579 11.3541 9.79963 11.2777Z",
    fill: "url(#paint47_linear_2262_4547)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0779 14.019C10.9141 14.0954 10.7436 14.1398 10.5733 14.1551L10.7418 14.5162C10.7887 14.6169 10.9084 14.6605 11.0092 14.6136L11.5775 14.3485C11.6783 14.3016 11.7218 14.1818 11.6748 14.0811L11.5064 13.72C11.3854 13.8406 11.2418 13.9426 11.0779 14.019Z",
    fill: "url(#paint48_linear_2262_4547)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0779 14.019C10.9141 14.0954 10.7436 14.1398 10.5733 14.1551L10.7418 14.5162C10.7887 14.6169 10.9084 14.6605 11.0092 14.6136L11.5775 14.3485C11.6783 14.3016 11.7218 14.1818 11.6748 14.0811L11.5064 13.72C11.3854 13.8406 11.2418 13.9426 11.0779 14.019Z",
    fill: "url(#paint49_linear_2262_4547)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06707 12.0116L8.66963 11.9769C8.55891 11.9672 8.46132 12.0491 8.45163 12.1598L8.39697 12.7845C8.38728 12.8952 8.46919 12.9928 8.57988 13.0025L8.977 13.0373C8.88379 12.6884 8.92135 12.326 9.06707 12.0116Z",
    fill: "url(#paint50_linear_2262_4547)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 12.2943L11.9005 12.2595C11.9937 12.6084 11.9562 12.9708 11.8104 13.2851L12.2079 13.3199C12.3186 13.3296 12.4162 13.2477 12.4259 13.137L12.4805 12.5123C12.4903 12.4016 12.4083 12.304 12.2976 12.2943Z",
    fill: "url(#paint51_linear_2262_4547)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 12.2943L11.9005 12.2595C11.9937 12.6084 11.9562 12.9708 11.8104 13.2851L12.2079 13.3199C12.3186 13.3296 12.4162 13.2477 12.4259 13.137L12.4805 12.5123C12.4903 12.4016 12.4083 12.304 12.2976 12.2943Z",
    fill: "url(#paint52_linear_2262_4547)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2262_4547",
    x1: 4.03468,
    y1: 4.0347,
    x2: 10.1621,
    y2: 10.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2262_4547",
    x1: 10.7782,
    y1: 10.7781,
    x2: 3.57502,
    y2: 3.57494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2262_4547",
    x1: 7.43137,
    y1: 8.2722,
    x2: 7.43137,
    y2: 13.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2262_4547",
    x1: 9.75105,
    y1: 8.96412,
    x2: 12.0367,
    y2: 10.4743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2262_4547",
    x1: 10.0187,
    y1: 10.0187,
    x2: 5.35127,
    y2: 5.35123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2262_4547",
    x1: 6.94743,
    y1: 6.01488,
    x2: 5.92681,
    y2: 3.02857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2262_4547",
    x1: 5.35402,
    y1: 6.43404,
    x2: 3.46396,
    y2: 5.52679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2262_4547",
    x1: 9.1095,
    y1: 6.97979,
    x2: 7.18163,
    y2: 6.76557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2262_4547",
    x1: 8.90171,
    y1: 8.41403,
    x2: 7.16287,
    y2: 7.73363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2262_4547",
    x1: 23.6587,
    y1: 15.278,
    x2: 4.49245,
    y2: 2.13672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2262_4547",
    x1: 20.5997,
    y1: 19.7394,
    x2: 1.43345,
    y2: 6.59814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2262_4547",
    x1: 23.1779,
    y1: 15.9791,
    x2: 4.01165,
    y2: 2.83786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2262_4547",
    x1: 21.0805,
    y1: 19.0381,
    x2: 1.91426,
    y2: 5.89687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2262_4547",
    x1: 22.9295,
    y1: 16.3416,
    x2: 3.76319,
    y2: 3.20041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2262_4547",
    x1: 21.329,
    y1: 18.6759,
    x2: 2.16268,
    y2: 5.53469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2262_4547",
    x1: 23.8022,
    y1: 15.0687,
    x2: 4.63588,
    y2: 1.92745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2262_4547",
    x1: 20.4563,
    y1: 19.9488,
    x2: 1.29,
    y2: 6.80751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2262_4547",
    x1: 23.9782,
    y1: 14.8121,
    x2: 4.81187,
    y2: 1.67087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2262_4547",
    x1: 20.2803,
    y1: 20.2054,
    x2: 1.11399,
    y2: 7.06419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2262_4547",
    x1: 21.9858,
    y1: 17.7179,
    x2: 2.8195,
    y2: 4.57668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2262_4547",
    x1: 22.2726,
    y1: 17.2996,
    x2: 3.10638,
    y2: 4.15832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2262_4547",
    x1: 7.27806,
    y1: 5.36991,
    x2: 7.69609,
    y2: 5.36991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2262_4547",
    x1: 8.38698,
    y1: 6.20878,
    x2: 8.68255,
    y2: 6.50435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2262_4547",
    x1: 7.10756,
    y1: 7.10766,
    x2: 7.69168,
    y2: 7.69182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1027,
    stopColor: "#C0EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2579,
    stopColor: "#ABEBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4463,
    stopColor: "#89E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6607,
    stopColor: "#5ADEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#1ED5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2262_4547",
    x1: 7.43137,
    y1: 7.41425,
    x2: 7.43137,
    y2: 7.95863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0290CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    stopColor: "#0290CF",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0290CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2262_4547",
    x1: 7.41697,
    y1: 7.417,
    x2: 7.82603,
    y2: 7.82606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0290CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    stopColor: "#0290CF",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0290CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2262_4547",
    x1: 13.3032,
    y1: 8.75811,
    x2: 11.9061,
    y2: 8.27576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2262_4547",
    x1: 4.05703,
    y1: 0.295892,
    x2: 6.06506,
    y2: 2.30392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2262_4547",
    x1: -0.271343,
    y1: 8.23052,
    x2: 2.87113,
    y2: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2262_4547",
    x1: 0.295904,
    y1: 4.05694,
    x2: 2.3039,
    y2: 6.06497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2262_4547",
    x1: 3.48981,
    y1: 11.9915,
    x2: 6.63228,
    y2: 15.1339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24CE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2262_4547",
    x1: 11.2083,
    y1: 6.84727,
    x2: 14.8935,
    y2: 10.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2262_4547",
    x1: 14.222,
    y1: 9.86098,
    x2: 11.6129,
    y2: 7.25185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2262_4547",
    x1: 10.7051,
    y1: 10.1402,
    x2: 10.9756,
    y2: 10.6889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2262_4547",
    x1: 10.6942,
    y1: 9.89959,
    x2: 10.1764,
    y2: 10.3942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2262_4547",
    x1: 15.3539,
    y1: 7.32933,
    x2: 15.7017,
    y2: 7.94764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2262_4547",
    x1: 13.0648,
    y1: 5.87293,
    x2: 13.8228,
    y2: 5.87293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2262_4547",
    x1: 13.0648,
    y1: 11.3036,
    x2: 13.8228,
    y2: 11.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2262_4547",
    x1: 12.9493,
    y1: 11.0973,
    x2: 12.9493,
    y2: 11.7802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2262_4547",
    x1: 10.5501,
    y1: 7.31665,
    x2: 10.1502,
    y2: 8.01802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2262_4547",
    x1: 15.145,
    y1: 9.85525,
    x2: 15.7305,
    y2: 10.2146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2262_4547",
    x1: 15.1838,
    y1: 10.1513,
    x2: 14.8997,
    y2: 10.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2262_4547",
    x1: 8.97306,
    y1: 12.1069,
    x2: 12.0795,
    y2: 13.2359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2262_4547",
    x1: 11.5135,
    y1: 13.0302,
    x2: 9.31407,
    y2: 12.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2262_4547",
    x1: 9.56737,
    y1: 14.1341,
    x2: 9.87005,
    y2: 14.3769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2262_4547",
    x1: 9.49653,
    y1: 13.9988,
    x2: 9.33168,
    y2: 14.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2262_4547",
    x1: 11.4847,
    y1: 11.2716,
    x2: 11.8504,
    y2: 11.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2262_4547",
    x1: 9.77846,
    y1: 11.049,
    x2: 10.2141,
    y2: 10.8456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2262_4547",
    x1: 11.2355,
    y1: 14.1697,
    x2: 11.6711,
    y2: 13.9663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2262_4547",
    x1: 11.1138,
    y1: 14.0821,
    x2: 11.2971,
    y2: 14.4746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2262_4547",
    x1: 8.72072,
    y1: 12.5532,
    x2: 8.67906,
    y2: 13.0636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2262_4547",
    x1: 12.0424,
    y1: 12.7793,
    x2: 12.4752,
    y2: 12.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2262_4547",
    x1: 12.144,
    y1: 12.939,
    x2: 12.1192,
    y2: 13.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetable);
export default __webpack_public_path__ + "static/media/timetable.040205ff921f6f13f145b107a733609c.svg";
export { ForwardRef as ReactComponent };